import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {MaterialModule} from "./material";
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import {AngularFireModule} from "@angular/fire";
import {AngularFirestoreModule} from "@angular/fire/firestore";
import { TournamentsListComponent } from './modules/tournaments/tournaments-list/tournaments-list.component';
import { RankingComponent } from './modules/ranking/ranking.component';
import { ParticipantsComponent } from './modules/participants/participants.component';
import {MainModule} from "./modules/main/main.module";
import {MAT_DATE_LOCALE} from "@angular/material/core";

import { registerLocaleData } from '@angular/common';
import localeUk from '@angular/common/locales/uk';
import {AngularFireStorageModule} from "@angular/fire/storage";
import {AngularFireAnalyticsModule, UserTrackingService} from "@angular/fire/analytics";
import { RulesComponent } from './modules/rules/rules.component';
import {HelpersModule} from "./modules/helpers/helpers.module";
import { CoursesComponent } from './modules/courses/courses.component';
import { MainPageComponent } from './modules/main-page/main-page.component';
import { ChampionshipsComponent } from './modules/championships/championships.component';
import { ContactsComponent } from './modules/contacts/contacts.component';
import { SETTINGS as FIRESTORE_SETTINGS } from '@angular/fire/firestore';

registerLocaleData(localeUk, 'uk');

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    RankingComponent,
    ParticipantsComponent,
    RulesComponent,
    MainPageComponent,
    ContactsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    MainModule,
    HelpersModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'uk-UA'},
    { provide: LOCALE_ID, useValue: 'uk' },
    UserTrackingService,
    { provide: FIRESTORE_SETTINGS, useValue: { experimentalForceLongPolling: true } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
